/**
 * 차량 모델 사진. 관리자(출고요청 등록·수정 폼)와 화주사 사이트(출고요청 상세)가 같이 쓴다. (DOM-PDI-001 5.6)
 * - 사진 서버의 `{모델코드}_{색상코드}.webp`를 보인다. (예: https://www.newpla.net/nova/porsche-imgs/9YBAI1_0E.webp)
 * - 사진이 없으면 서버가 `{모델코드}.webp` → `porsche.webp` 순서로 대신 준다(서버 nginx 설정).
 * - 서버에서 사진을 못 받으면 앱 assets의 기본 사진(Y1ADJ1)을 보인다.
 */
const VEHICLE_MODEL_PHOTO_BASE_URL = 'https://www.newpla.net/nova/porsche-imgs/';

/** 서버 주소 규칙은 영문·숫자만 받는다. 다른 글자가 있으면 서버가 대신 줄 사진 없이 404를 낸다 */
const PHOTO_CODE_PATTERN = /^[A-Za-z0-9]+$/;

export const VEHICLE_MODEL_PHOTO_DEFAULT_URL = 'assets/app/vehicle/model/Y1ADJ1.jpg?thumbnail=0x270';

/** 모델코드·색상코드의 사진 주소. 색상코드가 없으면 모델 사진, 모델코드가 없으면 서버 기본 사진 */
export function vehicleModelPhotoUrl(modelCode?: string | null, colorCode?: string | null): string {
  if (!modelCode || !PHOTO_CODE_PATTERN.test(modelCode)) return `${VEHICLE_MODEL_PHOTO_BASE_URL}porsche.webp`;
  if (!colorCode || !PHOTO_CODE_PATTERN.test(colorCode)) return `${VEHICLE_MODEL_PHOTO_BASE_URL}${modelCode}.webp`;
  return `${VEHICLE_MODEL_PHOTO_BASE_URL}${modelCode}_${colorCode}.webp`;
}

/** img (error): 서버에서 사진을 못 받으면 앱 기본 사진으로 바꾼다. 기본 사진도 없으면 더 바꾸지 않는다 */
export function onVehicleModelPhotoError(event: Event): void {
  const img = event.target as HTMLImageElement;
  if (img.getAttribute('src') !== VEHICLE_MODEL_PHOTO_DEFAULT_URL) {
    img.setAttribute('src', VEHICLE_MODEL_PHOTO_DEFAULT_URL);
  }
}
